import { render, staticRenderFns } from "./TabelaTurmas.vue?vue&type=template&id=0a08cd2c&"
import script from "./TabelaTurmas.vue?vue&type=script&lang=js&"
export * from "./TabelaTurmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports